<script setup>
import { useHttp, useTimeout } from "vutil";
import { ref, watchEffect } from "vue";

const addr = defineModel("addr");
const zip  = defineModel("zip");
const city = defineModel("city");
const lat  = defineModel("lat");
const lng  = defineModel("lng");

const props = defineProps(["nearby"]);

const invalid = "Please select a valid address";
const active = ref(false);
const query = ref();
const valid = ref();
const { data: addrs, get } = useHttp(d =>
{
	for (const a of d.adresser)
		a.title = `${a.adressetekst}, ${a.postnummer} ${a.poststed}`;

	console.log("result", d.adresser.length);

	if (d.adresser.length === 1)
		select(d.adresser[0]);

	return d.adresser;
});
const tmr = useTimeout(() => query.value.length > 2 &&
	get("https://ws.geonorge.no/adresser/v1/sok?treffPerSide=100&sok=" + encodeURIComponent(query.value)));

watchEffect(() => {
	const set = !!addr.value && !!zip.value && !!city.value;
	query.value = set ? `${addr.value}, ${zip.value} ${city.value}` : "";
	valid.value = set ? "" : invalid;
	console.log("watchEffect", set, addr.value, zip.value, city.value);
});

function input()
{
	valid.value = invalid;
	tmr.set(500);
}

function select(a)
{
	console.log("select", a);

	query.value = a.title;
	valid.value = "";
	addr.value = a.adressetekst;
	zip.value  = a.postnummer;
	city.value = a.poststed;
	lat.value  = a.representasjonspunkt.lat;
	lng.value  = a.representasjonspunkt.lon;
}

if (props.nearby)
	get(`https://ws.geonorge.no/adresser/v1/punktsok?treffPerSide=100&radius=100&lat=${lat.value}&lon=${lng.value}`);
</script>

<template>
	<input v-bind="$attrs" v-model.trim="query" v-valid="valid" autocomplete="off" type="text"
		@input="input" @click="active = true" @focus="active = true" @blur="active = false">
	<div v-if="active && addrs && addrs.length > 1" class="autocomplete-menu">
		<div>
			<div v-for="a in addrs" @mousedown.prevent @click="select(a); active = false">{{ a.title }}</div>
		</div>
	</div>
</template>
